<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-book">
<h1>About the Book</h1>
<p>Henrietta (Ria) is seventeen and never been kissed. While one part of her wants a boyfriend, another part of her is confused. Then Ria meets Flynn. Sweet and smart with a sly grin and an intense gaze, Flynn seems to be the kind of boy that Ria has been thinking about. But as their relationship deepens, Ria senses that Flynn is keeping secrets—dark, dangerous ones.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?7e11c580